// extracted by mini-css-extract-plugin
export default {"actions":"Facturas_actions__gL1Io","link":"Facturas_link__dFFkq","facturaLink":"Facturas_facturaLink__Unxy5"};